import { Injectable } from '@angular/core';
import { FiltersAbstractService } from '../../../common-page-components/classes/filters-abstract-service';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { CategoryCombo, TextFilter, RangeDateFilterStore, EventAthleteResultsCombo, DateFilterStore, YesNotCombo } from '../../../common-page-components/stores/filters-store/filters-store';
import { BoostrapAthleteResultsComponent } from '../components/boostrap-athlete-results/boostrap-athlete-results.component';

@Injectable({
  providedIn: 'root'
})
export class ResultsAthleteFiltersService extends FiltersAbstractService {

  /**
   * Categories combo.
   *
   * @memberof ResultsAthleteFiltersService
   */
  categoriesCombo = this.common_service.athleteCategoriesCombo;

  /**
   * Text filter.
   *
   * @memberof ResultsAthleteFiltersService
   */
  textFilter = new TextFilter('results-text-filter');

  /**
   * Range date combo.
   *
   * @memberof ResultsAthleteFiltersService
   */
  rangeDate = new RangeDateFilterStore(
    "range_date",
    new DateFilterStore(
      "from",
      "From",
      undefined,
      undefined,
      new BehaviorSubject({ value: undefined })
    ),
    new DateFilterStore(
      "to",
      "To",
      undefined,
      undefined,
      new BehaviorSubject({ value: new Date() })
    )
  );

  /**
   * Event type combo.
   *
   * @memberof ResultsAthleteFiltersService
   */
  eventTypeCombo = new EventAthleteResultsCombo('Event:', 'event-results-combo');

  /**
   * Podiums combo.
   *
   * @memberof ResultsAthleteFiltersService
   */
  podiumsCombo = new YesNotCombo('Podiums only:', 'podiums-combo', { Name: "No", Value: false });

  constructor(public common_service: FiltersAthleteGeneralService) {
    super();
  }

  /**
   *
   * @inheritdoc
   * @memberof ResultsAthleteFiltersService
   */
  generateDefaultValues(): void {
  }

  /**
   *
   * @inheritdoc
   * @memberof ResultsAthleteFiltersService
   */
  getDataStreamWithFilters(): Observable<any> {
    return;
  }
}
